//TODO get this from server
export const recordTypes = {
  checkRequest: {
    name: "checkRequest",
    label: "Check",
    auditable: true,
    actions: {
      search: {
        name: "search",
        label: "Search",
      },
      view: {
        name: "view",
        label: "View",
      },
      create: {
        //for old records
        name: "create",
        label: "Create",
        auditable: true,
        legacy: true,
      },
      createKycCheck: {
        name: "createKycCheck",
        label: "Create KYC Check",
        auditable: true,
      },
      createAmlCheck: {
        name: "createAmlCheck",
        label: "Create AML Check",
        auditable: true,
      },
      allocate: {
        name: "allocate",
        label: "Allocate",
        auditable: true,
      },
      cancel: {
        name: "cancel",
        label: "Cancel",
        auditable: true,
      },
      restart: {
        //for old records
        name: "restart",
        label: "Restart Cancelled",
        auditable: true,
        legacy: true,
      },
      restartCancelled: {
        name: "restartCancelled",
        label: "Restart Cancelled",
        auditable: true,
      },
      restartCompleted: {
        name: "restartCompleted",
        label: "Restart Completed",
        auditable: true,
      },
      revertCompleted: {
        name: "revertCompleted",
        label: "Revert Completed",
        intenal: true,
      },
      expire: {
        name: "expire",
        label: "Expire",
        auditable: true,
      },
    },
  },
  record: {
    name: "record",
    auditable: true,
    label: "Record",
    actions: {
      search: {
        name: "search",
        label: "Search",
      },
      filterByScore: {
        name: "filterByScore",
        label: "Filter By Score",
      },
      view: {
        name: "view",
        label: "View",
        auditable: true,
      },
      viewKycFields: {
        name: "viewKycFields",
        label: "View KYC Fields",
      },
      viewKycLinks: {
        name: "viewKycLinks",
        label: "View KYC Links",
      },
      viewAmlFields: {
        name: "viewAmlFields",
        label: "View AML Fields",
      },
      viewSensitiveFields: {
        name: "viewSensitiveFields",
        label: "View Sensitive Fields",
      },
      viewKycDocuments: {
        name: "viewKycDocuments",
        label: "View KYC Documents",
      },
      viewKycDocumentContents: {
        name: "viewKycDocumentContents",
        label: "View KYC Document Contents",
      },
      viewAmlDocuments: {
        name: "viewAmlDocuments",
        label: "View AML Documents",
      },
      viewAmlDocumentContents: {
        name: "viewAmlDocumentContents",
        label: "View Aml Document Contents",
      },
      viewAmlLinks: {
        name: "viewAmlLinks",
        label: "View AML Links",
      },
      viewAddresses: {
        name: "viewAddresses",
        label: "View Addresses",
      },
      viewAssociations: {
        name: "viewAssociations",
        label: "View Associations",
      },
      viewRelatedEntities: {
        name: "viewRelatedEntities",
        label: "View Related Entities",
      },
      viewScoreComments: {
        name: "viewScoreComments",
        label: "View Score Comments",
      },
      create: {
        name: "create",
        label: "Create",
        auditable: true,
      },
      addAddress: {
        name: "addAddress",
        label: "Add Record Address",
        auditable: true,
      },
      addKycLink: {
        name: "addKycLink",
        label: "Add KYC Link",
        auditable: true,
      },
      addKycDocument: {
        name: "addKycDocument",
        label: "Add KYC Document",
        auditable: true,
      },
      addAmlDocument: {
        name: "addAmlDocument",
        label: "Add AML Document",
        auditable: true,
      },
      addAmlLink: {
        name: "addAmlLink",
        label: "Add AML Link",
        auditable: true,
      },
      addAssociation: {
        name: "addAssociation",
        label: "Add Association",
        auditable: true,
      },
      addRelatedEntity: {
        name: "addRelatedEntity",
        label: "Add Related Entity",
        auditable: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
      },
      updateKycFields: {
        name: "updateKycFields",
        label: "Update KYC Fields",
        auditable: true,
      },
      updateAmlFields: {
        name: "updateAmlFields",
        label: "Update AML Fields",
        auditable: true,
      },
      updateAddress: {
        name: "updateAddress",
        label: "Update Record Address",
        auditable: true,
      },
      updateKycLink: {
        name: "updateKycLink",
        label: "Update KYC Link",
        auditable: true,
      },
      updateKycDocumentName: {
        name: "updateKycDocumentName",
        label: "Update KYC Document Name",
        auditable: true,
      },
      updateAmlDocumentName: {
        name: "updateAmlDocumentName",
        label: "Update AML Document Name",
        auditable: true,
      },
      updateAmlLink: {
        name: "updateAmlLink",
        label: "Update AML Link",
        auditable: true,
      },
      updateAssociation: {
        name: "updateAssociation",
        label: "Update Association",
        auditable: true,
      },
      markConfidential: {
        name: "markConfidential",
        label: "Mark Confidential",
        auditable: true,
      },
      unmarkConfidential: {
        name: "unmarkConfidential",
        label: "Unmark Confidential",
        auditable: true,
      },
      requestToBlock: {
        name: "requestToBlock",
        label: "Request Record Block",
        auditable: true,
      },
      requestToUnblock: {
        name: "requestToUnblock",
        label: "Request Record Unblock",
        auditable: true,
      },
      finalizeKycScore: {
        name: "finalizeKycScore",
        label: "Finalize KYC Score",
        auditable: true,
      },
      finalizeAmlScore: {
        name: "finalizeAmlScore",
        label: "Finalize AML Score",
        auditable: true,
      },
      finalizeAmlScoreWithRisk: {
        name: "finalizeAmlScoreWithRisk",
        label: "Finalize AML Score at Risk",
        auditable: true,
      },
      approveKycScore: {
        name: "approveKycScore",
        label: "Approve KYC Score",
        auditable: true,
      },
      approveAmlScore: {
        name: "approveAmlScore",
        label: "Approve AML Score",
        auditable: true,
      },
      referAmlToDealTeam: {
        name: "referAmlToDealTeam",
        label: "Refer Aml To Deal Team",
        auditable: true,
      },
      referBackAmlFromDealTeam: {
        name: "referBackAmlFromDealTeam",
        label: "Refer Back Aml From Deal Team",
        auditable: true,
      },
      expireScore: {
        name: "expireScore",
        label: "Expire Score",
        auditable: true,
      },
      uploadApprovalDocument: {
        name: "uploadApprovalDocument",
        label: "Upload Approval Document",
        auditable: true,
      },
      updateScores: {
        name: "updateScores",
        label: "Update Scores",
        auditable: true,
        internal: true,
      },
      removeAddress: {
        name: "removeAddress",
        label: "Remove Record Address",
        auditable: true,
      },
      removeKycLink: {
        name: "removeKycLink",
        label: "Remove KYC Link",
        auditable: true,
      },
      removeAmlLink: {
        name: "removeAmlLink",
        label: "Remove AML Link",
        auditable: true,
      },
      removeKycDocument: {
        name: "removeKycDocument",
        label: "Remove KYC Document",
        auditable: true,
      },
      removeAmlDocument: {
        name: "removeAmlDocument",
        label: "Remove Aml Document",
        auditable: true,
      },
      removeAssociation: {
        name: "removeAssociation",
        label: "Remove Association",
        auditable: true,
      },
      removeRelatedEntity: {
        name: "removeRelatedEntity",
        label: "Remove Related Entity",
        auditable: true,
      },
      exportRecord: {
        name: "exportRecord",
        label: "Export Record",
      },
      augmentData: {
        name: "augmentData",
        label: "Augment Record",
        auditable: true,
      },
      viewAuditRecords: {
        name: "viewAuditRecords",
        label: "View Record Audit",
      },
      viewClientDocumentRequests: {
        name: "viewClientDocumentRequests",
        label: "View Client Document Requests",
      },
      requestClientDocuments: {
        name: "requestClientDocuments",
        label: "Request Client Documents",
        auditable: true,
      },
    },
  },
  country: {
    name: "country",
    auditable: true,
    label: "Country",
    isAdmin: true,
    actions: {
      view: {
        name: "view",
        label: "View",
      },
      create: {
        name: "create",
        label: "Create",
        auditable: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
      },
    },
  },
  countryRegulator: {
    name: "countryRegulator",
    auditable: true,
    label: "Country Regulator",
    isAdmin: true,
    actions: {
      view: {
        name: "view",
        label: "View",
      },
      create: {
        name: "create",
        label: "Create",
        auditable: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
      },
    },
  },
  countryExchange: {
    name: "countryExchange",
    auditable: true,
    label: "Country Exchange",
    isAdmin: true,
    actions: {
      view: {
        name: "view",
        label: "View",
      },
      create: {
        name: "create",
        label: "Create",
        auditable: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
      },
    },
  },
  countryRiskData: {
    name: "countryRiskData",
    auditable: true,
    label: "Country Risk Data",
    isAdmin: true,
    actions: {
      view: {
        name: "view",
        label: "View",
      },
      upload: {
        name: "upload",
        label: "Upload",
        auditable: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
      },
    },
  },
  auditRecord: {
    name: "auditRecord",
    isAdmin: true,
    label: "Audit Record",
    actions: {
      view: {
        name: "view",
        label: "View",
      },
    },
  },
  accessRule: {
    name: "accessRule",
    label: "Access Rule",
    actions: {
      viewSelf: {
        name: "viewSelf",
        label: "View own access details",
      },
      view: {
        name: "view",
        label: "View",
        isAdmin: true, //Fix this
      },
      create: {
        name: "create",
        label: "Create",
        auditable: true,
        isAdmin: true,
      },
      update: {
        name: "update",
        label: "Update",
        auditable: true,
        isAdmin: true,
      },
      remove: {
        name: "remove",
        label: "Remove",
        auditable: true,
        isAdmin: true,
      },
    },
  },
  system: {
    name: "system",
    label: "System",
    actions: {
      clearCache: {
        name: "clearCache",
        label: "Clear Cache",
      },
    },
  },
  adminDashboard: {
    name: "adminDashboard",
    label: "Dashboard",
    isAdmin: true,
    actions: {
      view: {
        name: "view",
        label: "View",
      },
    },
  },
  documentType: {
    name: "documentType",
    label: "Document Type",
    actions: {
      view: {
        name: "view",
        label: "View",
      },
    },
  },
};

export const processActions = {
  finalizeScore: "Finalize Score",
  approveScore: "Approve Score",
  rejectScore: "Reject Score",
  sendBackScore: "Send Back Score",
};

export const scoreValues = {
  blocked: "Blocked",
  high: "High",
  medium: "Medium",
  low: "Low",
  cannotScore: "No Score",
};

export const onGoingcheckStatuses = [
  "Escalated",
  "Blocked",
  "Request Sent",
  "Referred To Deal Team",
  "Escalated Proceed At Risk",
  "Under Review",
];
